import React from "react";

import { BadgeFillDto } from "services/menuItemBadges/restModels";
import { fillToCss } from "shared/lib/badgeFill";

import { Pill } from "./styles";

interface BadgePillProps {
    title: string;
    fill: BadgeFillDto;
    textColor: string;
    className?: string;
}

/*
* Плашка бейджа, как её увидит гость. Полностью prop-driven: её же рисует редактор позиции —
* чипами выбранных бейджей, поэтому в кит она не уезжает (это домен, а не примитив).
* */
export const BadgePill = ({ title, fill, textColor, className }: BadgePillProps) => (
    <Pill className={className} $background={fillToCss(fill)} $textColor={textColor}>
        {title}
    </Pill>
);
